import { IDict } from "./types";

export const ru: IDict = {
  Jobs: "Задания",
  "No Jobs": "Нет заданий",
  Billing: "Оплата",
  Credits: "Кредиты",
  "Pay Per Use": "Оплата за использование",
  "Feature Voting": "Голосование за функции",
  "Free Karaoke Left": "Осталось бесплатных караоке",
  "Upgrade Now to Create More": "Обновите сейчас, чтобы создать больше",
  "Storage is Full": "Хранилище заполнено",
  "Youka is running out of storage space":
    "Заканчивается место в хранилище Youka",
  "Please free up at least 1 GB before creating new karaoke":
    "Освободите не менее 1 ГБ перед созданием нового караоке",
  "Click the button to check again": "Нажмите кнопку для повторной проверки",
  "No Internet Connection": "Нет интернет-соединения",
  "Youka cannot connect to the internet":
    "Youka не может подключиться к интернету",
  "Please make sure you have internet connection":
    "Убедитесь, что у вас есть интернет-соединение",
  "Update is ready": "Обновление готово",
  "Click the button to update": "Нажмите кнопку для обновления",
  "Library Folder": "Папка библиотеки",
  "Export Folder": "Папка экспорта",
  "Sync Model": "Модель синхронизации",
  "Max Video Quality": "Максимальное качество видео",
  "Speed / Compression Preset": "Скорость / Пресет сжатия",
  Change: "Изменить",
  "dialogs.upgrade.upgrade_to_pro":
    "Эта функция доступна в Pro-плане, обновитесь, чтобы разблокировать её.",
  "dialogs.upgrade.upgrade_to_standard":
    "Эта функция доступна в Standard-плане, обновитесь, чтобы разблокировать её.",

  heads_up: "Внимание!",
  "dialogs.edit_lyrics.not_supported":
    "Выбранный вами язык в настоящее время не поддерживается для автоматической синхронизации текста. Однако вы можете сохранить прогресс и вручную синхронизировать текст с помощью редактора строк.",
  "dialogs.create.title": "Создать новое караоке",
  "dialogs.create.description":
    "Заполните форму ниже, чтобы создать новое караоке. Вы можете использовать аудио- или видеофайл, текст песни не обязателен.",
  "dialogs.edit_lyrics.description":
    "После сохранения начнется процесс синхронизации, вы можете отслеживать прогресс в разделе «Задания».",
  "dialogs.upgrade.see_plans": "Просмотреть планы",
  "dialogs.upgrade.unlock": "Разблокировать",

  "comps.sync_editor.attach_previous": "Присоединить к предыдущему слову",
  "comps.sync_editor.attach_next": "Присоединить к следующему слову",
  "comps.plans.title":
    "Выберите план, который лучше всего соответствует вашим потребностям. Вы всегда можете повысить или понизить план.",
  "Font Size": "Размер шрифта",
  Spacing: "Межстрочный интервал",
  Outline: "Контур",
  "Margin Bottom": "Нижний отступ",
  "Max Chars per Line": "Макс. символов в строке",
  Bold: "Жирный",
  Italic: "Курсив",
  Shadow: "Тень",
  month: "месяц",
  songs: "песни",
  Title: "Заголовок",
  "Save and Sync": "Сохранить и синхронизировать",
  Lyrics: "Текст песни",
  Update: "Обновить",
  Playlist: "Плейлист",
  Canceling: "Отмена",
  Play: "Воспроизвести",
  "Lyrics Language": "Язык текста песни",
  "Background Image": "Фоновое изображение",
  "Basic Version": "Базовая версия",
  "Standard Version": "Стандартная версия",
  "Pro Version": "Профессиональная версия",
  "Trial Version": "Пробная версия",
  "No Active Plan": "Нет активного плана",
  "Days Left in Trial": "Осталось дней в пробной версии",
  Paste: "Вставить",
  "Sync Lyrics": "Синхронизировать текст",
  Show: "Показать",
  Settings: "Настройки",
  Retry: "Повторить",
  "Create Karaoke": "Создать караоке",
  Canceled: "Отменено",
  Reset: "Сбросить",
  "Edit Video": "Редактировать видео",
  Download: "Загрузить",
  "Edit Metadata": "Редактировать метаданные",
  "Subtitle Designer": "Дизайнер субтитров",
  Export: "Экспортировать",
  year: "год",
  Basic: "Базовый",
  Standard: "Стандартный",
  Pro: "Профессиональный",
  Accept: "Принять",
  "Add new word": "Добавить новое слово",
  "Add to queue": "Добавить в очередь",
  "An unknown error occurred": "Произошла неизвестная ошибка",
  Annually: "Ежегодно",
  "Are you sure you want to delete this karaoke song?":
    "Вы уверены, что хотите удалить эту караоке-песню?",
  "Artist Name": "Имя исполнителя",
  "Audio or Video File": "Аудио или видеофайл",
  Audio: "Аудио",
  "Auto Karaoke Generator": "Авто-генератор караоке",
  "Auto Lyrics Sync": "Авто-синхронизация текста",
  "Cancel Plan": "Отменить план",
  Cancel: "Отменить",
  Close: "Закрыть",
  "Create Karaoke from song": "Создать караоке из песни",
  "Create Karaoke from local files": "Создать караоке из локальных файлов",
  "Create new karaoke": "Создать новое караоке",
  Create: "Создать",
  "Current Plan": "Текущий план",
  "Dark Mode": "Темный режим",
  Decline: "Отклонить",
  "Delete word": "Удалить слово",
  Delete: "Удалить",
  "Edit Lyrics": "Редактировать текст",
  Edit: "Редактировать",
  "Export to mp3/mp4": "Экспортировать в mp3/mp4",
  "Go Back to EULA": "Вернуться к лицензионному соглашению",
  "Go back": "Назад",
  "Go forward": "Вперед",
  Home: "Главная",
  "I accept the terms and commit to avoiding unlicensed use of copyrighted content":
    "Я принимаю условия и обязуюсь не использовать контент без лицензии",
  Instruments: "Инструменты",
  Key: "Тональность",
  Library: "Библиотека",
  "Light Mode": "Светлый режим",
  "Line Level Sync": "Синхронизация на уровне строки",
  "Line Level": "Уровень строки",
  "Lyrics (optional)": "Текст песни (опционально)",
  "Lyrics Sync Editor": "Редактор синхронизации текста",
  Manage: "Управлять",
  Monthly: "Ежемесячно",
  "Most popular": "Самый популярный",
  "No new notifications": "Нет новых уведомлений",
  "No results": "Нет результатов",
  "No songs in library": "В библиотеке нет песен",
  "No songs in queue": "В очереди нет песен",
  Notifications: "Уведомления",
  Off: "Выключено",
  Or: "Или",
  "Plan canceled, will end in": "План отменен, завершится через",
  "Play word in loop": "Воспроизвести слово в цикле",
  "Preparing Youka": "Подготовка Youka",
  "Process 2 karaokes at a time": "Обрабатывать 2 караоке одновременно",
  "Process 5 karaokes at a time": "Обрабатывать 5 караоке одновременно",
  Queue: "Очередь",
  Ready: "Готово",
  "Remove from queue": "Удалить из очереди",
  "Resume plan": "Возобновить план",
  "Save and Resync": "Сохранить и пересинхронизировать",
  Save: "Сохранить",
  "Saving...": "Сохранение...",
  Search: "Поиск",
  "Select plan": "Выбрать план",
  "Sign In": "Войти",
  "Sign Out": "Выйти",
  "Sign Up": "Зарегистрироваться",
  "Song Name": "Название песни",
  "Start typing to search or paste YouTube URL":
    "Начните вводить для поиска или вставьте URL YouTube",
  "Start typing to search": "Начните вводить для поиска",
  "Subtitle Track": "Трек субтитров",
  Subtitles: "Субтитры",
  Tempo: "Темп",
  "Terms and Conditions": "Условия и положения",
  "This action cannot be undone.": "Это действие нельзя отменить.",
  "Thumbnail URL": "URL миниатюры",
  "To keep the karaoke fun going, please upgrade":
    "Чтобы продолжить веселье с караоке, пожалуйста, обновите план",
  "Unlock Premium Features with an Upgrade!":
    "Разблокируйте премиум-функции с обновлением!",
  "Update Payment Method": "Обновить способ оплаты",
  "Upgrade to Pro plan to enable": "Обновитесь до Pro-плана для активации",
  Upgrade: "Обновить",
  Version: "Версия",
  Video: "Видео",
  Vocals: "Вокал",
  "Waiting in queue": "Ожидание в очереди",
  "Word Level Sync": "Синхронизация на уровне слова",
  "Word Level": "Уровень слова",
  "You need to accept the EULA to use Youka":
    "Для использования Youka вам нужно принять лицензионное соглашение",
  "Your lyrics have been saved successfully. A resync is currently in progress. You can monitor the progress in the notification area. Once the resync is complete, you'll be able to see the changes - just hit 'play'.":
    "Ваш текст был успешно сохранен. Сейчас идет процесс пересинхронизации. Вы можете отслеживать прогресс в области уведомлений. Как только пересинхронизация завершится, вы сможете увидеть изменения — просто нажмите 'воспроизвести'.",
  "Your trial version of Youka has expired":
    "Срок действия вашей пробной версии Youka истек",
  "dialogs.youtube.title":
    "Установите плагин yt-dlp для поиска и воспроизведения онлайн-видео",
  "dialogs.youtube.description":
    "Пожалуйста, прочитайте и примите следующие предупреждения перед активацией плагина.",
  "dialogs.youtube.agree":
    "Я прочитал(а) и понял(а) вышеуказанные предупреждения",
  "dialogs.youtube.install": "Установить плагин",
  "dialogs.youtube.install_success": "Плагин успешно установлен",
  "dialogs.youtube.install_success_description":
    "Теперь вы можете искать и воспроизводить онлайн-видео",
  "dialogs.youtube.install_error": "Не удалось установить плагин",
  "alert.youtube.description":
    "Плагин для поиска и загрузки онлайн-видео (yt-dlp) не установлен. Нажмите, чтобы установить плагин.",
  "alert.youtube.install": "Установить плагин",
  "dialogs.settings.enable_youtube": "Активировать плагин yt-dlp",

  "dialogs.youtube.warnings": [
    {
      title: "Соблюдение закона",
      description:
        "Убедитесь, что ваше использование этого плагина полностью соответствует всем применимым законам и условиям сервисов, с которыми вы взаимодействуете, таких как YouTube.",
    },
    {
      title: "Авторские права и лицензирование",
      description:
        "Этот плагин может позволять действия (например, скачивание контента), которые могут нарушать законы об авторских правах или соглашения о лицензировании при неправильном использовании. Важно уважать права создателей контента и использовать плагин только для законных целей.",
    },
    {
      title: "Отказ от поддержки",
      description:
        "Активация этого плагина не означает поддержку или одобрение со стороны нашей компании. Плагин является отдельной сущностью, и мы не несем ответственности за его работу или последствия его использования.",
    },
    {
      title: "Ответственность пользователя",
      description:
        "Вы несете полную ответственность за любые действия, которые вы совершаете с использованием этого плагина. Это включает в себя любые правовые последствия, возникающие в результате его неправильного использования или нарушения условий обслуживания.",
    },
    {
      title: "Потенциальные риски",
      description:
        "Будьте внимательны: неправильное использование плагина может привести к блокировке учетной записи или правовым действиям со стороны заинтересованных сторон или платформ.",
    },
    {
      title: "Осознанное согласие",
      description:
        "Активируя этот плагин, вы подтверждаете, что прочитали и поняли эти предупреждения и принимаете полную ответственность за использование плагина.",
    },
  ],
  "model.auto": "Автоматический выбор лучшей модели.",
  "model.audioshake.transcription":
    "Лучшая модель транскрибирует и выравнивает текст, но доступна только для пользователей Pay Per Use и Trial (занимает до 10 минут).",
  "model.audioshake":
    "Модель выравнивает текст по предоставленным данным, но ошибки могут привести к неудовлетворительным результатам (занимает до 10 минут).",
  "model.wav2vec2":
    "Модель выравнивает текст по предоставленным данным и поддерживает почти все языки. (занимает до 30 секунд)",
  "model.whisper":
    "Модель транскрибирует и выравнивает текст, хотя точность может быть невысокой, синхронизация приемлема (занимает до 2 минут).",
  "sync.line.instructions": [
    "Нажмите кнопку 'Воспроизвести', чтобы начать процесс синхронизации",
    "Нажмите 'Установить начало' при воспроизведении первой строки",
    "Нажмите 'Установить конец' после воспроизведения последней строки",
    "Продолжайте синхронизировать все строки",
  ],
  Undo: "Отменить",
  Redo: "Повторить",
  "Set Start": "Установить начало",
  "Set End": "Установить конец",
  "dialogs.edit_lyrics.transcription":
    "Модель самостоятельно транскрибирует песню и определяет текст, после чего вы можете отредактировать его с помощью инструмента синхронизации.",
  "Duet Editor": "Редактор дуэтов",
  "Manual Line Sync": "Ручная синхронизация строк",
  "New Style": "Новый стиль",
  Style: "Стиль",
  Singer: "Певец",
  "Style Editor": "Редактор стиля",
  Word: "Слово",
  Line: "Строка",
  "Split Line": "Разделить строку",
  "Upgrade to Enable": "Обновитесь для активации",
  upgrade_description:
    "Вы можете слушать или загружать уже созданные караоке-треки. Для создания новых треков требуется обновление.",
  "dialogs.global.no_user.title": "Нет активного плана",
  "dialogs.global.no_user.description": "Обновите план для продолжения",
  "dialogs.global.no_role.title": "Нет активного плана",
  "dialogs.global.no_role.description": "Обновите план для продолжения",
  "dialogs.global.blocked_ip.title": "Ваш IP заблокирован",
  "dialogs.global.blocked_ip.description": "Свяжитесь с поддержкой",
  "dialogs.global.rate_limit.title": "Превышен лимит запросов",
  "dialogs.global.rate_limit.description":
    "Вы можете переключиться на план Pay Per Use для неограниченного доступа.",
  "dialogs.global.disk_full.title": "Хранилище заполнено",
  "dialogs.global.disk_full.description":
    "Освободите место для продолжения работы с Youka",
  "dialogs.global.too_big.title": "Файл превышает допустимый размер",
  "dialogs.global.too_big.description":
    "Обратите внимание, что максимальная продолжительность аудиофайла не должна превышать 15 минут.",
  Help: "Помощь",
  Original: "Оригинал",
  Sort: "Сортировать",
  "sort.date.asc": "Дата создания (сначала старые)",
  "sort.date.desc": "Дата создания (сначала новые)",
  "sort.title.asc": "Название (А-Я)",
  "sort.title.desc": "Название (Я-А)",
  "dialogs.trim.title": "Обрезка",
  "dialogs.trim.description":
    "Используйте регулируемую границу на звуковой волне, чтобы выбрать часть песни, которую вы хотите сохранить.",
  Start: "Начало",
  End: "Конец",
  Time: "Время",
  Related: "Связанные",
  preserve_vocals: "Сохранить вокал",
  preserve_vocals_description:
    "Переключите, чтобы сохранить вокал, такой как бэк-вокал.",
  "Separate Audio": "Отделить аудио",
  "Separate Model": "Модель разделения",
  "Add Lyrics": "Добавить текст",
  "Background Image or Video": "Фоновое изображение или видео",
  Docs: "Документы",
  Watch: "Смотреть",
  Hide: "Скрыть",
  "watch.sync.title": "Как легко исправить синхронизацию текста?",
  "watch.sync.url": "https://www.youtube.com/watch?v=kEHzfAwQBzo",
  "watch.review.title": "Оставьте отзыв о Youka на Trustpilot",
  Review: "Отзыв",
  "Import Subtitles": "Импорт субтитров",
  Import: "Импортировать",
  "How to use": "Как использовать",
  Uppercase: "Прописные",
  "Open Dual Screen": "Открыть двойной экран",
  "Close Dual Screen": "Закрыть двойной экран",
  "Import Karaoke File": "Импортировать файл караоке",
  "dialogs.import_karaoke.title": "Импортировать караоке из файла",
  "dialogs.import_karaoke.description":
    "Импортируйте существующий файл караоке, такой как MP3/MP4 с встроенными текстами, файл LRC с тем же названием или файл Karafun.",
  optional: "опционально",
  "Trial Expired": "Пробный период истёк",
  "Subtitles Settings": "Настройки субтитров",
  Milliseconds: "Миллисекунды",
  Seconds: "Секунды",
  Text: "Текст",
  Enabled: "Включено",
  Duration: "Длительность",
  Gap: "Промежуток",
  Offset: "Смещение",
  "Min Duration": "Минимальная длительность",
  "Max Duration": "Максимальная длительность",
  "Fade In": "Фейд-ин",
  "Fade Out": "Фейд-аут",
  "plugins.title.title": "Название песни",
  "plugins.title.description": "Показать название песни в начале видео",
  "plugins.gap_text.title": "Текст промежутка",
  "plugins.gap_text.description":
    "Показать текст в промежутке между субтитрами",
  "plugins.gap_progress_bar.title": "Показать полосу прогресса промежутка",
  "plugins.gap_progress_bar.description":
    "Показать полосу прогресса в промежутке между субтитрами",
  "plugins.fade.title": "Эффект фейда",
  "plugins.fade.description": "Показать эффект фейда в субтитрах",
  "plugins.offset.title": "Смещение",
  "plugins.offset.description":
    "Смещение субтитров на определенное количество секунд",
  "plugins.countdown.title": "Отсчёт промежутка",
  "plugins.countdown.description":
    "Показать отсчёт в промежутке между субтитрами",
  Auto: "Автоматический",
  Subword: "Подслово",
  Countdown: "Отсчёт",
  "Restart required": "Перезапустить",
  "Reindex Library": "Переиндексировать библиотеку",
  "Create playlist": "Создать плейлист",
  "Are you sure you want to delete?": "Вы уверены, что хотите удалить?",
  "Add to playlist": "Добавить в плейлист",
  "New playlist": "Новый плейлист",
  "Remove from this playlist": "Удалить из этого плейлиста",
  Songs: "Песни",
  Playlists: "Плейлисты",
  Name: "Имя",
  Photo: "Фото",
  "No playlists": "Нет плейлистов",
  "Welcome to Youka": "Добро пожаловать в Youka",
  "Search songs online": "Поиск песен онлайн",
  "create.file.title": "Создать караоке из файла",
  "create.file.description":
    "Загрузите свой MP3, MP4 или другие файлы, чтобы мгновенно создать караоке-видео с синхронизированными словами.",
  "create.online.title": "Создать караоке из онлайн песен",
  "create.online.description":
    "Ищите песни в интернете или вставьте URL песни, чтобы мгновенно создать караоке-видео с синхронизированными словами.",
  "Change Background": "Изменить фон",
  "Duet Line Split": "Разделить строку дуэта",
  Both: "Оба",
  Custom: "Пользовательский",
  Edited: "Редактированный",
  Trimmed: "Обрезано",
  Instrumental: "Инструментальное",
  "Add Subword": "Добавить подслово",
  "plugins.max_chars.title": "Максимум символов на строку",
  "plugins.max_chars.description": "Ограничить количество символов на строку",
  Limit: "Ограничение",
  "Background Box": "Корзина фона",
  Height: "Высота",
  Width: "Ширина",
  Alpha: "Альфа",
  Color: "Цвет",
  Duplicate: "Дублировать",
  "Convert to 16x9": "Преобразовать в 16x9",
  "Resize Video": "Изменить размер видео",
  "Line Alignment": "Выравнивание строки",
  "Shadow Color": "Цвет тени",
  "Outline Color": "Цвет контура",
  "Active Color": "Активный цвет",
  "Secondary Color": "Вторичный цвет",
  "Primary Color": "Основный цвет",
  "Auto Alignment": "Автоматическое выравнивание",
  "Auto Color": "Автоматический цвет",
  "Singer 1": "Певец 1",
  "Singer 2": "Певец 2",
  "Top Row": "Верхняя строка",
  "Bottom Row": "Нижняя строка",
  "Border Style": "Стиль границы",
  "Font Name": "Имя шрифта",
  "Experimental Subtitles Display": "Отображение экспериментальных субтитров",
  Position: "Позиция",
  "Timing Indicator": "Индикатор времени",
  General: "Общий",
  Styles: "Стили",
  Thumbnail: "Миниатюра",
  "create.url.title": "Создать караоке из URL",
  "create.url.description": "Создать караоке из URL, поддерживаемого yt-dlp",
  "Paste a URL or start typing to search":
    "Вставьте URL или начните вводить для поиска",
  Top: "Верх",
  Bottom: "Низ",
  Center: "Центр",
  "Auto Line Break": "Автоматическое разделение строки",
  "Fill Color": "Цвет заливки",
  "Active Line Color": "Цвет активной строки",
  "Waiting Line Color": "Цвет строки ожидания",
  "Set as Default": "Установить по умолчанию",
  Default: "По умолчанию",
  "Make Default": "Установить по умолчанию",
  Image: "Изображение",
  Pause: "Пауза",
  File: "Файл",
  "Debug Info": "Информация для отладки",
  "File Type": "Тип файла",
  Language: "Язык",
  "Reset Settings": "Сбросить настройки",
  "Failed to start Youka": "Не удалось запустить Youka",
  Legacy: "Традиционный",
  Transcription: "Транскрипция",
  Alignment: "Выравнивание",
  Imported: "Импортированный",
  "With Backing Vocals": "С вокалом",
  Stem: "Стем",
  Clear: "Очистить",
  "Open Directory": "Открыть директорию",
  "Advanced Settings": "Расширенные настройки",
  "How to Add a Background Black Box to Subtitles":
    "Как добавить черный фон к субтитрам",
  "How to Adjust the Line Length": "Как настроить длину строки",
  "How to Cancel Your Subscription": "Как отменить подписку",
  "How to Center Subtitles": "Как выровнять субтитры по центру",
  "How to Delete a Karaoke": "Как удалить караоке",
  "How to Edit the lyrics": "Как редактировать текст песни",
  "How to Fix the Sync": "Как исправить синхронизацию",
  "How to Keep Choirs": "Как сохранить хоры",
  "How to Keep the Original Singer’s Voice":
    "Как сохранить голос оригинального исполнителя",
  "How to Set Up a Duet": "Как настроить дуэт",
  "How to Speed Up the Download Process": "Как ускорить процесс загрузки",
  "How to Transfer Your Karaoke Library to a New Computer":
    "Как перенести библиотеку караоке на новый компьютер",
  "How to Trim a Karaoke Video": "Как обрезать видео караоке",
  FAQ: "FAQ",
  "library.description":
    "Получите доступ и управляйте всеми караоке-треками, которые вы создали. Редактируйте, организуйте и совершенствуйте свои проекты.",
  "How to Change the Background Video": "Как изменить видеофона",
  "Auto Size": "Автоматический размер",
  "dialogs.global.no_credits.title": "Нет доступных кредитов",
  "dialogs.global.no_credits.description":
    "Пожалуйста, пополните кредит для продолжения",
  "Credits are over! Click to buy more":
    "Кредиты закончились! Нажмите, чтобы купить еще",
  "How to Add a Line Break": "Как добавить перенос строки",
  "dialogs.global.no_user.many_emails_description":
    "Доступ был заблокирован из-за нескольких входов с использованием разных адресов электронной почты. Пожалуйста, приобретите подписку, чтобы продолжить.",
  "dialogs.global.no_user.virtual_machine_description":
    "Доступ был заблокирован, так как вы используете виртуальную машину. Чтобы получить доступ к бесплатной пробной версии, установите Youka на стандартную операционную систему. Если у вас есть подписка, пожалуйста, продлите её, чтобы восстановить доступ. Если вам не нужно постоянное создание караоке, вы можете выбрать план с оплатой за использование, оплачивая только создание нового контента караоке.",
  "Import Stem": "Импортировать стем",
  "Active Outline Color": "Активный цвет контура",
  "Inactive Outline Color": "Неактивный цвет контура",
  "Inactive Line Color": "Неактивный цвет строки",
  "Active Line": "Активная строка",
  "Inactive Line": "Неактивная строка",
  "End Extra": "Дополнительное время в конце",
  Expand: "Развернуть",
  Collapse: "Свернуть",
  "Copy Line": "Копировать строку",
  "Copy Word": "Копировать слово",
  "Cut Line": "Вырезать строку",
  "Cut Word": "Вырезать слово",
  "Delete Line": "Удалить строку",
  "Delete Subword": "Удалить подслово",
  "Delete Word": "Удалить слово",
  "Add Line": "Добавить строку",
  "Add Word": "Добавить слово",
  // "Add Subword": "Добавить подслово",
  "Paste Line": "Вставить строку",
  "Paste Word": "Вставить слово",
  "Paste Subword": "Вставить подслово",
  "Play Line": "Воспроизвести строку",
  "Play Word": "Воспроизвести слово",
  "Select Line": "Выбрать строку",
  "Manual Sync": "Ручная синхронизация",
  "Trim Start": "Обрезать начало",
  "Trim End": "Обрезать конец",
  "Creating will use 1 credit": "Создание потребует 1 кредит",
  All: "Все",
  "Number of Singers": "Количество певцов",
  "Style Mapping": "Сопоставление стилей",
  "Associate subtitle styles with singers": "Связать стили субтитров с певцами",
  "Upper first line": "Верхняя первая строка",
  "Upper second line": "Верхняя вторая строка",
  "Lower first line": "Нижняя первая строка",
  "Lower second line": "Нижняя вторая строка",
  Lock: "Блокировка",
  "2 Lines": "2 строки",
  "4 Lines": "4 строки",
  Static: "Статический",
  Dynamic: "Динамический",
  "Subtitles Type": "Тип субтитров",
  "Danger Zone": "Опасная зона",
  Copy: "Копировать",
  Copied: "Скопировано",
  "Copy Settings": "Копировать настройки",
  "cta.social.title": "Получите 50 кредитов БЕСПЛАТНО!",
  "cta.social.description":
    "Поделитесь постом о Youka в социальных сетях, отметьте нас и получите 50 бесплатных кредитов за каждую платформу!",
  "cta.social.description.2":
    "Нажмите, чтобы посетить страницу Youka в Facebook, поставьте лайк, поделитесь постом и отправьте свой email в чате, чтобы получить 50 бесплатных кредитов!",
  "Merge Line": "Слить строку",
  Player: "Плеер",
  "Key Step": "Шаг тональности",
  "Tempo Step": "Шаг темпа",
  "Shift Line Forward": "Сдвинуть строку вперед",
  "Shift Line Backward": "Сдвинуть строку назад",
  "create.description":
    "Создайте караоке из аудио- или видеофайлов (MP3, MP4 и других), или вставьте URL, чтобы мгновенно создать караоке-видео с синхронизированными текстами.",
  "No file chosen": "Нет выбранного файла",
  "Choose File": "Выбрать файл",
  "Watch Quick Start Video": "Смотреть видео-инструкцию",
  "Export Settings": "Экспорт настроек",
  "Import Settings": "Импорт настроек",
  "Video Guides": "Видео-инструкции",
  "Quick Start Guide": "Инструкция по быстрому запуску",
  "Lyrics Sync Guide": "Инструкция по синхронизации текста",
  Resolution: "Разрешение",
  "Subtitles Preset": "Предустановка субтитров",
  Preset: "Предустановка",
  Done: "Готово",
  "New Style Mapping": "Новое соответствие стиля",
  Horizontal: "Горизонтальный",
  Vertical: "Вертикальный",
  Square: "Квадрат",
  New: "Новый",
  "New Subtitles Preset": "Новая предустановка субтитров",
  "Change Aspect Ratio": "Изменить соотношение сторон",
  "copyright.title.a": "Я принимаю",
  "copyright.title.b": "Подтверждение использования музыки",
  "copyright.description":
    "Отметив этот флажок, вы подтверждаете, что (A) вы обладаете всеми правами на музыку, включенную в это видео; или (B) музыка является общественным достоянием; или (C) у вас есть разрешение от всех необходимых правообладателей на использование музыки на платформе Youka.",
  "Add Intro Video": "Добавить вступительное видео",
  "dialogs.intro.description":
    "Добавьте пользовательское видео в начало караоке",
  Transition: "Переход",
  Fade: "Затухание",
  "Circle Open": "Открытие круга",
  "Circle Close": "Закрытие круга",
  "Diagonal Open": "Диагональное открытие",
  "Diagonal Close": "Диагональное закрытие",
  "Smooth Left": "Плавно влево",
  "Smooth Right": "Плавно вправо",
  Squares: "Квадраты",
  Dissolve: "Растворение",
  Type: "Тип",
  "Song Title": "Название песни",
  Artists: "Исполнители",
  Artist: "Исполнитель",
  "Parse Titles": "Анализировать названия песен",
  "sort.artist.asc": "Исполнитель (А-Я)",
  "sort.artist.desc": "Исполнитель (Я-А)",
  "Title Style": "Стиль названия",
  "Artist Style": "Стиль исполнителя",
  "Analyse Library": "Анализировать библиотеку",
  "No Filter": "Без фильтра",
  "credits.message_one": "Это потребует {{count}} кредита",
  "credits.message_other": "Это потребует {{count}} кредитов",
  "credits.badge_one": "{{count}} кредит",
  "credits.badge_other": "{{count}} кредитов",
  "Provide song lyrics to save credits":
    "Добавьте текст песни, чтобы сэкономить кредиты",
  "Upload to Cloud Library": "Загрузить в облачную библиотеку",
  "Cloud Library": "Облачная библиотека",
  "Open Cloud Library": "Открыть облачную библиотеку",
};
